<div class="intro discussion-wrapper">
  @if (isFacultyActivities()) {
    <h1>Posts and replies from faculty</h1>
  }
  @if (!isFacultyActivities()) {
    <h1>Posts and replies</h1>
  }
  <div>
    <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='offlineMessage'></ebs-offline-message>
    @if (!isOffline) {
      <div>
        @if (!isFacultyActivities()) {
          <div>
            <p class="mt-2">Replies to any post you have participated in.</p>
          </div>
        }
        @if (isFacultyActivities()) {
          <div>
            <div class="card">
              <ebs-faculty-activity [truncateContentLength]="truncateContentLength"
                [isDiscussionContent]="isDiscussionContent" [courseCode]="courseCode"
                [postAndReplySearchResults]="facultyPostAndReplySearchResults"
              [loadingData]="loadingFacultyPostAndReplyData"></ebs-faculty-activity>
              @if (loadingMoreFacultyPosts) {
                <ebs-spinner [spinnerMessage]="'getting more faculty post and replies'"
                  >
                </ebs-spinner>
              }
              @if (!isLastFacultyPostAndReplyPage() && !isOffline) {
                <div class="row mt-3">
                  <div class="col-12 col-sm-6 offset-sm-3 text-center">
                    <span (click)="loadMoreFacultyPostAndReply($event)" class="btn btn-primary btn-sm">
                      <i class="fas fa-arrow-down"></i> View more faculty replies
                    </span>
                  </div>
                </div>
              }
              <div class="row">
                <div class="col-12 col-sm-6 offset-sm-3 text-center loaded-style">
                  Loaded {{facultyPostAndReplySearchResults.length}} of {{totalFacultyItems }}
                </div>
              </div>
            </div>
          </div>
        }
        @if (!isFacultyActivities()) {
          <div>
            <div class="card">
              <ebs-group-activity [truncateContentLength]="truncateContentLength"
                [isDiscussionContent]="isDiscussionContent" [courseCode]="courseCode"
                [postAndReplySearchResults]="postAndReplySearchResults" [loadingData]="loadingPostAndReplyData">
              </ebs-group-activity>
              @if (loadingMorePosts) {
                <ebs-spinner [spinnerMessage]="'getting more replies'">
                </ebs-spinner>
              }
              @if (!isLastPostAndReplyPage() && !isOffline) {
                <div class="row mt-3">
                  <div class="col-12 col-sm-6 offset-sm-3 text-center">
                    <span (click)="loadMorePostAndReply($event)" class="btn btn-primary btn-sm">
                      <i class="fas fa-arrow-down"></i> View more replies
                    </span>
                  </div>
                </div>
              }
              <div class="row">
                <div class="col-12 col-sm-6 offset-sm-3 text-center loaded-style">
                  Loaded {{postAndReplySearchResults.length}} of {{totalItems}}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>